import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

import './maskedPassword.scss';

export const MaskedPassword = ({ charStyle = 'icon', icon = 'paw', numChars = 8 }) => {
  const MaskCharacter = () => {
    if (charStyle === 'icon') {
      return <Icon icon={icon} />;
    }
    return <>*</>;
  };

  return (
    <span className={`maskedPassword maskedPassword_${charStyle}`}>
      <span className="sr-only">Masked password</span>
      {[...Array(numChars).keys()].map((arrayIndex) => (
        <MaskCharacter key={arrayIndex} />
      ))}
    </span>
  );
};

MaskedPassword.propTypes = {
  charStyle: PropTypes.oneOf(['css', 'icon']),
  icon: PropTypes.string,
  numChars: PropTypes.number
};
